import {
  createComponentExtension,
  createPlugin,
} from '@backstage/core-plugin-api';

export const plugin = createPlugin({
  id: 'github-actions-extensions',
});

export const ComponentEntityWorkflowsCard = plugin.provide(
  createComponentExtension({
    name: 'ComponentEntityWorkflowsCard',
    component: {
      lazy: () => import('./components').then(m => m.ComponentEntityWorkflowsCard),
    },
  }),
);

export const GroupEntityWorkflowsCard = plugin.provide(
  createComponentExtension({
    name: 'GroupEntityWorkflowsCard',
    component: {
      lazy: () => import('./components').then(m => m.GroupEntityWorkflowsCard)
    }
  })
)